export default "__VITE_ASSET__BuiZ4QBc__"